import React from 'react';

import {
	CHAT_ROOMS_NOTREDAME_SAUDE,
	PRODUCT_CODE,
	PRODUCT_NAME,
	ProductEnum,
	PRODUCT_FOOTER_NAME,
	EXTERNAL_LINK_NOTREDAME_SAUDE,
	PRODUCT_LINK_IOS_STORE,
	PRODUCT_LINK_ANDROID_STORE,
} from 'presentation/constants';
import {
	NotredameSaudeLogo,
	NotredameSaudeIcon,
	NotredameSaudeAns,
	NotredameSaudeAppIcon,
} from 'presentation/components/Logos';
import {AnsLogoProps, ProductIconProps, ProductLogoProps} from '../types';
import {useThemeStore} from 'presentation/store/useThemeStore';

const theme = useThemeStore.getState().theme;

export const notredameSaudeData = {
	productLogo: ({invertColor, nameColor, invertPlanTypeColor, ...props}: ProductLogoProps) => (
		<NotredameSaudeLogo
			nameColor={nameColor || (invertColor ? theme.brand.primary.white : undefined)}
			invertPlanTypeColor={invertPlanTypeColor}
			{...props}
		/>
	),
	productIcon: ({color, invertColor, ...props}: ProductIconProps) => (
		<NotredameSaudeIcon
			color={color || (invertColor ? theme.brand.primary.white : undefined)}
			{...props}
		/>
	),
	productAppIcon: (props: ProductIconProps) => <NotredameSaudeAppIcon {...props} />,
	ansLogo: (props?: AnsLogoProps) => <NotredameSaudeAns {...props} />,
	product: ProductEnum.NOTREDAME_SAUDE,
	productCode: PRODUCT_CODE.notredame,
	productName: PRODUCT_NAME.notredame,
	footerProductName: PRODUCT_FOOTER_NAME.notredame,
	links: EXTERNAL_LINK_NOTREDAME_SAUDE,
	chatRoom: CHAT_ROOMS_NOTREDAME_SAUDE,
	iosStoreLink: PRODUCT_LINK_IOS_STORE.notredame,
	androidStoreLink: PRODUCT_LINK_ANDROID_STORE.notredame,
};
